import InfoModal from "../modals/InfoModal";


export default function FormTextStack(props) {

    let color = "primary-200"
    if (props.color)
        color = `${props.color}-primary`

    return (
        <div>
            <div className="text-4xl mb-2 text-black font-bold leading-tight tracking-tight">
                {props.mainTitle} <span className = {`text-${color}`}>{props.colorTitle}</span>
            </div>

            <div className="text-base mb-8 mt-4 text-black font-light items-center leading-tight tracking-tight">
                {props.lines.map((lineContent) =>
                <div className="ml-1" key = {lineContent}>{lineContent}</div>
                )}
                <div className = "inline-flex ml-1">
                    {props.lastLine}&nbsp;
                    <InfoModal color = {props.color} title = {props.modalTitle} desc = {props.modalDesc}></InfoModal>
                </div>
                <br></br>
                
            </div>
            
        </div>
    )
}